import { render, staticRenderFns } from "./TheNavBar.vue?vue&type=template&id=1206d08a"
import script from "./TheNavBar.vue?vue&type=script&lang=js"
export * from "./TheNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports